"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DpRecommendations: {
        followUpAssessment: 'Follow Up Assessment',
        supportingContent: 'Supporting Content',
        supportingContentAriaLabel: 'Supporting content for Question {{itemLabel}}, {{name}}.',
    },
};
